import { useState, useRef, useEffect } from "react";

export default function BeforeAfterSlider({
  before,
  after,
  labelBefore = "Before",
  labelAfter = "After",
  height = "aspect-[16/10] md:aspect-[16/9]",
  tone = "dark", // "dark" | "light"
}) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  useEffect(() => {
    const move = (e) => {
      if (!dragging.current || !ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      const pct = Math.max(0, Math.min(100, (x / rect.width) * 100));
      setPos(pct);
    };
    const up = () => { dragging.current = false; };
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: true });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchend", up);
    };
  }, []);

  const chipBg = tone === "light" ? "bg-cream-100/95 text-ink-700" : "bg-ink-950/85 text-cream-100";

  return (
    <div
      ref={ref}
      className={`relative w-full overflow-hidden select-none ${height}`}
      data-testid="before-after-slider"
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt="before"
          className="absolute inset-0 h-full object-cover"
          style={{ width: `${(100 / pos) * 100}%`, maxWidth: 'none' }}
          draggable={false}
        />
      </div>
      <div className={`absolute top-4 left-4 text-[0.65rem] font-mono uppercase tracking-[0.22em] px-3 py-1.5 backdrop-blur ${chipBg}`}>
        {labelBefore}
      </div>
      <div className={`absolute top-4 right-4 text-[0.65rem] font-mono uppercase tracking-[0.22em] px-3 py-1.5 backdrop-blur ${chipBg}`}>
        <span className="text-ruby">●</span> {labelAfter}
      </div>

      <div
        className="absolute top-0 bottom-0 cursor-ew-resize"
        style={{ left: `${pos}%`, transform: "translateX(-50%)" }}
        onMouseDown={() => { dragging.current = true; }}
        onTouchStart={() => { dragging.current = true; }}
      >
        <div className="w-[2px] h-full bg-ruby" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-cream-100 border border-ruby flex items-center justify-center text-ruby shadow-lg shadow-ruby/30">
          <span className="text-xs font-mono">◄ ►</span>
        </div>
      </div>
    </div>
  );
}
